var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutDarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0892 10.1229C13.109 10.1083 13.125 10.0897 13.136 10.0684C13.147 10.0471 13.1528 10.0238 13.1528 10.0001C13.1528 9.97641 13.147 9.95305 13.136 9.93177C13.125 9.91049 13.109 9.89184 13.0892 9.87725L10.1539 7.69365C10.0462 7.61372 9.88665 7.68586 9.88665 7.81648L9.88665 9.26117L2.87671 9.26117C2.78556 9.26117 2.71099 9.33135 2.71099 9.41714L2.71099 10.5869C2.71099 10.6727 2.78556 10.7429 2.87671 10.7429L6.38064 10.7429L9.88458 10.7429L9.88458 12.1837C9.88458 12.3143 10.0441 12.3864 10.1518 12.3065L13.0892 10.1229ZM4.82861 2.86439L4.82861 4.03417C4.82861 4.11996 4.82856 6.35425 4.82856 7.7605C4.82856 7.84679 4.89852 7.91675 4.98481 7.91675C5.34939 7.91675 5.87023 7.91675 6.23481 7.91675C6.31828 7.91675 6.38002 7.84396 6.38064 7.7605C6.39106 6.35425 6.38064 4.19014 6.38064 4.19014L15.72 4.19014L15.72 15.81L6.38064 15.81C6.38064 15.81 6.39106 13.1251 6.38064 12.238C6.37967 12.155 6.31781 12.0834 6.23481 12.0834C5.87023 12.0834 5.34939 12.0834 4.98481 12.0834C4.89896 12.0834 4.82856 12.1394 4.82856 12.238C4.82856 12.9511 4.82856 15.8906 4.82856 15.966C4.82856 16.0518 4.82856 17.1358 4.82856 17.1358C4.82856 17.2216 4.90313 17.2917 4.99428 17.2917L16.6314 17.2917C16.9981 17.2917 17.2943 17.0129 17.2943 16.6679L17.2943 3.3323C17.2943 2.98721 16.9981 2.70842 16.6314 2.70842L4.99433 2.70842C4.90318 2.70842 4.82861 2.7786 4.82861 2.86439Z",
    fill: "#144154"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDarkBlue);
export default __webpack_public_path__ + "static/media/logoutDarkBlue.5bd533a0bafdec53069737cafe699e18.svg";
export { ForwardRef as ReactComponent };